import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';

import connectPopupAnalytics from '@r1-frontend/entities/ConnectDomruPopup/analytics';
import { CLIENT_REFERRAL_LINK } from '@r1-frontend/entities/ConnectDomruPopup/constants';
import { setView } from '@r1-frontend/entities/ConnectDomruPopup/context/actions';
import { useContextDispatch } from '@r1-frontend/entities/ConnectDomruPopup/context/hooks';
import { useIsMsk } from '@r1-frontend/entities/Layout/_deps/helpers/hooks/useIsMsk';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

const SelectConnectionMethod = () => {
    const router = useRouter();
    const isMsk = useIsMsk();
    const isDesktop = useMatchMediaByWidth(wideBreakpoints.mobile, true);

    const dispatch = useContextDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const { title, subtitle, description, bgPath } = {
        title: 'Не&nbsp;ждите звонка',
        subtitle: 'Оформите онлайн-заявку на&nbsp;подключение тарифа прямо на&nbsp;сайте&nbsp;&mdash; за&nbsp;пару минут.',
        description: 'Удобнее по&nbsp;телефону? Сейчас у&nbsp;нас много обращений&nbsp;&mdash; оператор перезвонит не&nbsp;сразу.',
        bgPath: '/static/images/connect-domru/bg.desktop.jpg',
    };

    const referralLink = isMsk ? '/landing/stabilnyj-internet' : CLIENT_REFERRAL_LINK;

    const handleClose = () => {
        dispatch(setView('none'));
    };

    const onClickReferralButton = useCallback(() => {
        if (location.pathname === referralLink) {
            handleClose();
        } else {
            setIsLoading(true);
            connectPopupAnalytics.applicationForm.move();
            router.push(referralLink).finally(() => setIsLoading(false));
        }
    }, []);

    const onShowRequestFormPopup = useCallback(() => {
        connectPopupAnalytics.applicationFormHeader.move();
        dispatch(setView('callback'));
    }, []);

    return (
        <DefaultPopup
            isOpen
            onClose={handleClose}
            width={isDesktop ? '600px' : '308px'}
            height={'auto'}
            fullWidth={true}
            data-test='become-client-popup'
        >
            <FullWidthListContainer $size={0}>
                <ST.TopBlock $desktop={[32, 32, 24]} $mobile={[24]} id={'topBlock'} bgPath={bgPath}>
                    <ListContainer
                        $direction={'column'}
                        $alignItems={isDesktop ? 'flex-start' : 'unset'}
                        $size={36}
                    >
                        <TextWrapper $lastIndent={false}>
                            <H3 dangerouslySetInnerHTML={{ __html: title }}/>
                            <Paragraph4 dangerouslySetInnerHTML={{ __html: subtitle }}/>
                        </TextWrapper>
                        <Button
                            bType={'action'}
                            loading={isLoading}
                            disabled={isLoading}
                            onClick={onClickReferralButton}
                            data-test='one-rouble-link'
                        >
                            Выбрать тариф
                        </Button>
                    </ListContainer>
                </ST.TopBlock>

                <IndentContainer $desktop={[24, 32, 32]} $mobile={[24, 32]} id={'bottomBlock'}>
                    <FullWidthListContainer
                        $direction={'column'}
                        $alignItems={isDesktop ? 'flex-start' : 'unset'}
                        $size={16}
                    >
                        <Paragraph4 dangerouslySetInnerHTML={{ __html: description }}/>
                        <Button
                            bType={'secondary'}
                            loading={isLoading}
                            disabled={isLoading}
                            onClick={onShowRequestFormPopup}
                        >
                            Позвоните мне
                        </Button>
                    </FullWidthListContainer>
                </IndentContainer>
            </FullWidthListContainer>
        </DefaultPopup>
    );
};

export default SelectConnectionMethod;
